export default "__VITE_ASSET__2abe212f__"